export default __webpack_public_path__ + "static/media/Gwalior1.ae757cbe.jpg";